import React, { useState, useEffect } from 'react';
import StatCard from './components/StatCard';
import NewDrivers from './components/NewDrivers';
import ExistingDrivers from './components/ExistingDrivers';
import { Users, Banknote, CreditCard, UserPlus } from 'lucide-react';
import api from './utils/api';
import { useSocket } from './context/SocketContext';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalAmountToTransfer: 0,
    totalDrivers: 0,
    pendingPayoutsCount: 0,
    newRegisteredDrivers: 0
  });
  const [loading, setLoading] = useState(true);
  const { socket } = useSocket();

  const fetchStats = async () => {
    try {
      const response = await api.get('/admin/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  useEffect(() => {
    if (!socket) return;

    // Listen for events that would change the stats
    socket.on('driver_approved', fetchStats);
    socket.on('payout_processed', fetchStats);

    return () => {
      socket.off('driver_approved', fetchStats);
      socket.off('payout_processed', fetchStats);
    };
  }, [socket]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading dashboard...
      </div>
    );
  }

  return (
    <div className="space-y-10 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <div className="flex flex-col gap-1">
        <h1 className="text-3xl font-extrabold text-[#121415] tracking-tight">Dashboard Overview</h1>
        <p className="text-[#909090] font-medium">Welcome back, Admin. Real-time stats for Travel Pass.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          title="Pending Settlements"
          value={`Rs ${stats.totalAmountToTransfer.toLocaleString()}`}
          change="Liquidity required"
          icon={Banknote}
          iconBg="bg-orange-100"
          iconColor="text-orange-600"
        />
        <StatCard
          title="Active Drivers"
          value={stats.totalDrivers.toString()}
          change="Verified Drivers"
          icon={Users}
          iconBg="bg-[#E8F5EE]"
          iconColor="text-[#05A664]"
        />
        <StatCard
          title="Pending Payouts"
          value={stats.pendingPayoutsCount.toString()}
          change="Awaiting transfer"
          icon={CreditCard}
          iconBg="bg-blue-100"
          iconColor="text-blue-600"
        />
        <StatCard
          title="Pending Approvals"
          value={stats.newRegisteredDrivers.toString()}
          change="New applications"
          icon={UserPlus}
          iconBg="bg-purple-100"
          iconColor="text-purple-600"
        />
      </div>

      <div className="space-y-10">
        <NewDrivers />
        <ExistingDrivers />
      </div>
    </div>
  );
};

export default Dashboard;